import SaleClientDetails from './SaleClientDetails/SaleClientDetails'
import SaleDocuments from './SaleDocuments/SaleDocuments'
import SaleInvoicesDetails from './SaleInvoicesDetails/SaleInvoicesDetails'
import SaleProjectDetails from './SaleProjectDetails/SaleProjectDetails'
import SaleSmallDetails from './SaleSmallDetails/SaleSmallDetails'
import SaleSupplierInvoiceDetails from './SaleSupplierInvoiceDetails/SaleSupplierInvoiceDetails'
import SaleSupplierInvoiceDocument from './SaleSupplierInvoiceDocument/SaleSupplierInvoiceDocument'

export const content = {
  SaleSmallDetails,
  SaleProjectDetails,
  SaleClientDetails,
  SaleSupplierInvoiceDetails,
  SaleInvoicesDetails,
  SaleDocuments,
  SaleSupplierInvoiceDocument
}
